import FacebookButton from './FacebookButton';
import GoogleButton from './GoogleButton';
import EmailButton from './EmailButton';

import { LOG_IN, SIGN_UP } from './ButtonWrapper';

const APPLE = 'apple';
const EMAIL = 'email';
const FACEBOOK = 'facebook';
const GOOGLE = 'google';

const elemAttrForAnalytics = (option) => {
  switch (option) {
    case FACEBOOK:
      return 'facebook_signup';
    case APPLE:
      return 'apple_signup';
    case EMAIL:
      return 'email_signup';
    case GOOGLE:
      return 'google_signup';
    default:
      return 'signup';
  }
};

export {
  APPLE,
  EMAIL,
  EmailButton,
  FACEBOOK,
  FacebookButton,
  GOOGLE,
  GoogleButton,
  LOG_IN,
  SIGN_UP,
  elemAttrForAnalytics
};
